import { format } from 'date-fns';
import numeral from 'numeral';
import { MG_FORMAT } from 'src/static/constants';

// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue) {
  return numeral(number).format();
}

export function fCurrency(number: InputValue) {
  const format = number ? numeral(number).format('$0,0.00') : '';

  return result(format, '.00');
}

export function fPercent(number: InputValue) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number: InputValue) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number: InputValue) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

// 핸드폰 번호 포맷팅 함수
export function fPhoneNumber(phone: InputValue) {
  if (typeof phone !== 'string') return '-';

  if (phone.length === 0) return '-';
  if (/^[0-9]{11}$/.test(phone)) {
    return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  return phone;
}

// 생년월일 포맷팅 함수 (날짜 형식 (YYYYMMDD))
export function fbirth(birth: string): string {
  if (typeof birth !== 'string' || birth.length === 0) return '-';

  if (/^[0-9]{8}$/.test(birth)) {
    return birth.replace(/(\d{4})(\d{2})(\d{2})/, '$1년 $2월 $3일');
  }

  return birth;
}
// 가격 포맷팅 함수 (원화 기준): 주어진 숫자를 천 단위로 콤마를 추가
export function fCurrencyKRW(amount: InputValue) {
  return amount !== null && amount !== undefined ? numeral(amount).format('0,0') : '-';
}

// 포매팅되지 않은 원래 숫자 값으로 변환하는 함수
export const unformatNumber = (value: string) => {
  return value.replace(/,/g, '');
};

// 날짜 포맷팅 함수
export const fDate = (
  value: string | number | null | undefined,
  format_: string = MG_FORMAT.DATE_FORMAT,
  defaultReturn = '-',
) => {
  try {
    if (!value) {
      return defaultReturn;
    }
    if (typeof value === 'string') {
      if (`${value}`.length < 2) {
        return defaultReturn;
      }
    } else if (typeof value === 'number') {
      if (value === 0) {
        return defaultReturn;
      }
    }
    return format(new Date(value), format_);
  } catch {
    return defaultReturn;
  }
};
